<template>
  <export-excel
    type="csv"
    class="export_btn"
    :name="`Home Visit activity list (${$route.params.month}/${$route.params.year}).csv`"
    :data="exportFieldsHandler"
    :footer="[`${$route.params.month}/${$route.params.year}`]"
  >
    <v-icon color="white" left>mdi-chevron-right-circle-outline</v-icon>Export
  </export-excel>
  
  <!-- <v-btn
          @click="exportData"
            color="teal accent-4"
            depressed
            dark
            class="mb-1 mr-3"
          >
  <v-icon color="white" left>mdi-chevron-right-circle-outline</v-icon> Export
  </v-btn> -->
  
</template>

<script>
import { mapGetters } from "vuex";

export default {
  computed: {
    ...mapGetters("HomeVisit", ["exportFieldsHandler"]),
   
    // formattedData() {
    //   // Ensure exportFieldsHandler is an array of rows
    //   return Array.isArray(this.exportFieldsHandler) ? this.exportFieldsHandler.map(row => {
    //     // Ensure row is an array
    //     return Array.isArray(row) ? row.map(cell => {
         
    //       return cell.slice(1);
    //     }) : row;
    //   }) : [];
    // }
  
  },
  data: () => ({}),

  methods: {

    exportData(){
      let data = {
        month:this.$route.params.month,
        year:this.$route.params.year,
        township_id: this.$route.query.township,
      }
   
      this.$store.dispatch("HomeVisit/exportHomeVisit", data);
    },
  },
};
</script>

<style scoped>
.export_btn {
  background: #ff4081;
  border-radius: 3px;
  color: white !important;
  letter-spacing: 1px;
  text-transform: uppercase;
  width: 150px;
  padding: 5px 15px;
  margin-bottom: 1px;
  cursor: pointer;
}
</style>
